import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img
            src="https://static.readdy.ai/image/52a4142c7107152be6de52470a5cfef9/445908a283d03328c84be0e5bfc330ab.png"
            alt="SafeStay Solutions Logo"
            className="h-10 sm:h-12 w-auto"
          />
        </Link>
        
        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center gap-6 xl:gap-8">
          <Link
            to="/why-choose-us"
            className={`text-sm xl:text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/why-choose-us')
                ? 'text-[#D4AF37]'
                : isScrolled
                ? 'text-gray-700 hover:text-[#D4AF37]'
                : 'text-white hover:text-[#D4AF37]'
            }`}
          >
            Why Choose Us
          </Link>
          <Link
            to="/services"
            className={`text-sm xl:text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/services')
                ? 'text-[#D4AF37]'
                : isScrolled
                ? 'text-gray-700 hover:text-[#D4AF37]'
                : 'text-white hover:text-[#D4AF37]'
            }`}
          >
            Services
          </Link>
          <Link
            to="/packages"
            className={`text-sm xl:text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isActive('/packages')
                ? 'text-[#D4AF37]'
                : isScrolled
                ? 'text-gray-700 hover:text-[#D4AF37]'
                : 'text-white hover:text-[#D4AF37]'
            }`}
          >
            Packages
          </Link>
          <Link
            to="/free-assessment"
            className="bg-[#D4AF37] text-[#1A2B4A] px-4 xl:px-6 py-2 xl:py-3 rounded-full font-semibold text-sm xl:text-base hover:bg-[#C4A137] transition-colors cursor-pointer whitespace-nowrap"
          >
            Free Assessment
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            isScrolled ? 'text-[#1A2B4A]' : 'text-white'
          }`}
          aria-label="Toggle menu"
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/why-choose-us"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block w-full text-left px-4 py-3 rounded-lg cursor-pointer ${
                isActive('/why-choose-us')
                  ? 'bg-[#D4AF37]/10 text-[#D4AF37] font-semibold'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Why Choose Us
            </Link>
            <Link
              to="/services"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block w-full text-left px-4 py-3 rounded-lg cursor-pointer ${
                isActive('/services')
                  ? 'bg-[#D4AF37]/10 text-[#D4AF37] font-semibold'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Services
            </Link>
            <Link
              to="/packages"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block w-full text-left px-4 py-3 rounded-lg cursor-pointer ${
                isActive('/packages')
                  ? 'bg-[#D4AF37]/10 text-[#D4AF37] font-semibold'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Packages
            </Link>
            <Link
              to="/free-assessment"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block w-full bg-[#D4AF37] text-[#1A2B4A] px-4 py-3 rounded-full font-semibold hover:bg-[#C4A137] transition-colors cursor-pointer text-center"
            >
              Free Assessment
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
